import SimpleBar from 'simplebar';

const scrollContainer = document.querySelectorAll('.js-scrollbar');

scrollContainer.forEach(
  scroller => new SimpleBar(scroller, {
    autoHide: false,
  }),
);
